import React from 'react'
import { mount } from '../utils/mount'
import { ProductListPage } from '../pages/product-list-page'

mount('#page-root', <ProductListPage />)